<div class="image-header-wrapper-overlay">
	<img
		class="image-header-overlay"
		loading="lazy"
		[src]="imageCaptureHeaderImg" />
	<div *ngIf="isColemnaVisible" class="image-colemna"></div>
	<div class="image-vector-3"></div>
	<div class="image-vector-2"></div>
	<div class="image-vector-1"></div>
	<p class="image-header-title">
		{{ imageCaptureHeaderTitle }}
	</p>
</div>
